
export function getDisplayName({ previewMode, settings, data }) {
    if (previewMode) {
        if (settings.lang !== "en") {
            return settings.location_display || "Enter City Name";
        }
        return data?.location?.name;
    }

    const weatherSettings = data?.media?.weather?.settings;
    return weatherSettings?.location_display || weatherSettings?.location;
}
